var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-switch',{attrs:{"value":_vm.value,"false-value":'0',"true-value":'1',"type":"is-success","disabled":_vm.disabled},on:{"input":function($event){return _vm.$emit('input', $event)}}},[_vm._v("\n  "+_vm._s(_vm.label)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }